export default function tryDecodeURI(val: string): string {
    if (typeof val === 'string') {
        try {
            return decodeURI(val);
        } catch (e) {
            // eslint-disable-line no-empty
        }
    }
    return val;
}
